import api from '../api'

export function onW2Change(companyId, responseCallback, errorCallback) {
  api
    .put(`/admin/company/${companyId}/toggle_w2`)
    .then(() => {
      responseCallback()
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export function onPositionDataChange(
  positionId,
  data,
  responseCallback,
  errorCallback
) {
  api
    .put(`/admin/positions/${positionId}`, data)
    .then((response) => {
      responseCallback(response)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export function approvePosition(positionId, responseCallback, errorCallback) {
  api
    .post(`/admin/listing/approve`, { position_id: positionId })
    .then((response) => {
      responseCallback(response)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export function updateMinPayPolicy(
  companyId,
  newMinutes,
  newStartDate,
  responseCallback,
  errorCallback
) {
  api
    .post(`/admin/company/${companyId}/min_pay_policy`, {
      min_pay_length_in_minutes: newMinutes,
      policy_start_date: newStartDate,
    })
    .then((response) => {
      responseCallback(response)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export function updateTakePercentage(
  companyId,
  data,
  responseCallback,
  errorCallback
) {
  // Data may need to be rekeyed to match the backend.
  if (data.rate1099) {
    data.rate_1099 = data.rate1099
    delete data.rate1099
  }
  if (data.w2Regular) {
    data.w2_regular = data.w2Regular
    delete data.w2Regular
  }
  if (data.w2Overtime) {
    data.w2_overtime = data.w2Overtime
    delete data.w2Overtime
  }
  if (data.w2Double) {
    data.w2_double = data.w2Double
    delete data.w2Double
  }
  api
    .post(`/admin/company/${companyId}/take_rate_percentage`, data)
    .then((response) => {
      responseCallback(response)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export function fetchUpcomingShiftsForPosition(
  positionId,
  companyId,
  responseCallback,
  errorCallback
) {
  api
    .post('/admin/graphql_dispatch/upcoming_shifts_for_position_d3e06369', {
      positionId: positionId,
      companyId: companyId,
    })
    .then((response) => {
      responseCallback(response)
    })
    .catch((error) => {
      errorCallback(error)
    })
}
